import { useEffect } from "react";
import { App as CapApp } from "@capacitor/app";

import FullScreenMobilePage from "../FullScreenMobilePage/FullScreenMobilePage";
import Button from "../Button/Button";
import ToastMessage from "../ToastMessage/ToastMessage";

import type { PlatformVersionInfo } from "../../connectors/appVersionApi";
import { APP_VERSION_TOAST_CONTAINER_ID } from "../../constants/appVersion";
import { openAppStore } from "../../utils/openAppStore";

import infoIcon from "../../assets/icons/info-light-icon.svg";

import styles from "./ForcedUpdateScreen.module.scss";

interface Props {
  platformInfo: PlatformVersionInfo | null;
}

const ForcedUpdateScreen = ({ platformInfo }: Props) => {
  const { content, footer } = styles;

  // Block Android hardware back so the user cannot bypass the gate.
  // Listener only attaches on native — web doesn't expose the event and
  // the gate doesn't run there anyway.
  useEffect(() => {
    let listener: { remove: () => void } | undefined;
    let cancelled = false;

    void (async () => {
      const handle = await CapApp.addListener("backButton", () => {
        // Intentional no-op: forced screen has no escape.
      });
      if (cancelled) {
        handle?.remove?.();
        return;
      }
      listener = handle;
    })();

    return () => {
      cancelled = true;
      listener?.remove?.();
    };
  }, []);

  return (
    <>
      <FullScreenMobilePage
        noLogo
        footerContent={
          <section className={footer}>
            <Button
              variant="primary"
              text="Actualizar"
              onPress={() => void openAppStore(platformInfo)}
            />
          </section>
        }
      >
        <div className={content}>
          <img src={infoIcon} alt="Ícono de información" />
          <h1>Necesitás actualizar la app para continuar</h1>
          <p>Esta versión ya no está disponible. Descargá la última versión para ingresar.</p>
        </div>
      </FullScreenMobilePage>
      <ToastMessage messageId={APP_VERSION_TOAST_CONTAINER_ID} position="top-center" />
    </>
  );
};

export default ForcedUpdateScreen;
